import { useQuery } from "@tanstack/react-query";
import { retrieveOwnProfile } from "../services/auth";

export const useOwnProfileQuery = (shouldFetch: boolean = true) => {
  return useQuery({
    queryFn: () => retrieveOwnProfile(),
    queryKey: ["ownProfile"],
    staleTime: 1000 * 5,
    enabled: shouldFetch,
  });
};
